import { Component, Input } from '@angular/core';
import { DataServiceService } from '../../services/data-service.service';
import { Orders } from '../../interfaces';

@Component({
  selector: 'app-washout-dialog',
  templateUrl: './washout-dialog.component.html',
  styleUrl: './washout-dialog.component.scss'
})
export class WashoutDialogComponent {

  @Input() allOrders: Orders[] = [];
  @Input() selectedOrderId: number = -1;
  @Input() trailers: any[] = [];

  constructor(private dataServiceService: DataServiceService) {}

  currentTrailerNumber: string = '';
  showStatusDialog: boolean = false;

  openDialog() {
    this.showStatusDialog = true;
  }

  prepareTrailerNumber() {
    const order = this.allOrders.find(o => o.order_id === this.selectedOrderId);
    if (order) {
      if (order.trailer_id) {
        if (this.trailers) {
          const trailer = this.trailers.find((t: { trailer_id: number; }) => t.trailer_id === order.trailer_id);
          if (trailer) {
            this.currentTrailerNumber = trailer.trailer_number;
          }
        }
      }
     else if (order.external_trailer_number) {
      this.currentTrailerNumber = order.external_trailer_number;
    }}

    if (!this.currentTrailerNumber) {
      console.error('No trailer number found');
      return;
    }

    if (order?.load_type === 'Plastic') {
      this.generateForm(this.currentTrailerNumber);
    } else {
      this.handleOtherWashout(this.currentTrailerNumber);
    }
  }

  generateForm(trailerNumber: string) {
    this.dataServiceService.generateForm(trailerNumber, 'plastic').subscribe({
      next: (blob: Blob) => {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Create and trigger download
        const link = document.createElement('a');
        const currentDate = new Date().toLocaleDateString().replace(/\//g, '-');
        link.href = url;
        link.download = `plastic-washout-form-${this.currentTrailerNumber}-${currentDate}.pdf`;
        
        // Trigger download and cleanup
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showStatusDialog = false;
      },
      error: (error) => {
        console.error('Failed to generate washout form:', error);
      }
    })
}

handleOtherWashout(trailerNumber: string) {
  
  this.dataServiceService.generateForm(trailerNumber, 'other').subscribe({
    next: (response: any) => {
      // Check if response is actually a Blob with PDF content
      if (response instanceof Blob && response.type === 'application/pdf') {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(response);
        
        // Create and trigger download
        const link = document.createElement('a');
        const currentDate = new Date().toLocaleDateString().replace(/\//g, '-');
        link.href = url;
        link.download = `washout-form-${this.currentTrailerNumber}-${currentDate}.pdf`;
        
        // Trigger download and cleanup
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showStatusDialog = false;
      } else {
        // Handle case where response is not a PDF blob
        console.error('Unexpected response format:', response);
        if (response instanceof Blob) {
          // Try to read the blob as text to see what it contains
          const reader = new FileReader();
          reader.onload = () => {
            console.error('Response content:', reader.result);
          };
          reader.readAsText(response);
        }
      }
    },
    error: (error) => {
      console.error('Failed to generate washout form:', error);
      
      // Try to extract more information from the error
      if (error.error instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorJson = JSON.parse(reader.result as string);
            console.error('Error details:', errorJson);
          } catch (e) {
            console.error('Error content (not JSON):', reader.result);
          }
        };
        reader.readAsText(error.error);
      }
    }
  });
}

}
